<opac-dialog size="small" [open]="isStatsModalOpen()" [title]="'history.stats.title' | translate" (closed)="close()">
  <app-user-history-stats-dialog-skeleton *ngIf="isLoading()"></app-user-history-stats-dialog-skeleton>

  <ng-container *ngIf="historyItem()">
    <app-user-history-stats-dialog-item
      [label]="icon().label | translate"
      [value]="historyItem().title"
    >
      <div class="main-icon">
        <opac-icon [icon]="icon().icon"></opac-icon>
      </div>
    </app-user-history-stats-dialog-item>

    <div class="statistics">
      <app-user-history-stats-dialog-item
        *ngIf="historyItem().loanStart as loanStart"
        [label]="'user.history.checkout.start' | translateByCustomerType:customerType().dbValue"
        [value]="loanStart | date"
      >
        <opac-icon icon="first_access"></opac-icon>
      </app-user-history-stats-dialog-item>

      <app-user-history-stats-dialog-item
        *ngIf="historyItem().loanEnd as loanEnd"
        [label]="'user.history.checkout.end' | translateByCustomerType:customerType().dbValue"
        [value]="loanEnd | date"
      >
        <opac-icon icon="return_date"></opac-icon>
      </app-user-history-stats-dialog-item>

      <app-user-history-stats-dialog-item
        *ngIf="historyItem().ebookTimeReading as timeReading"
        [label]="'user.history.checkout.consumptiontime' | translate"
        [value]="timeReading | duration"
      >
        <opac-icon icon="clock"></opac-icon>
      </app-user-history-stats-dialog-item>
    </div>
  </ng-container>
</opac-dialog>
